import styled from 'styled-components';

export const ConversationListContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: auto;
  min-width: 20%;
  max-width: 30%;
  height: 100%;

  background-color: ${(props) => props.theme.colors.greys.lighter};

  border-left: 1px solid ${(props) => props.theme.colors?.greys?.light};
`;

export const ConversationListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 65px;
  padding: 12px;
`;

export const ConversationListContent = styled.div`
  display: flex;
  flex-direction: column;

  overflow-y: auto;

  /* padding: 12px; */
  flex: 1;

  gap: 8px;
`;

export const ConversationListGroup = styled.div`
  display: flex;
  flex-direction: column;

  padding: 12px;

  max-height: 50%;

  gap: 8px;
`;

export const ConversationItemsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 8px;

  max-height: 100%;

  overflow-y: auto;
`;

export const ConversationItem = styled.div`
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;

  gap: 12px;

  background-color: ${(props) => (props.isActive ? props.theme.colors.greys.light : 'transparent')};

  &:hover {
    background-color: ${(props) => props.theme.colors.greys.medium};
  }
`;

export const ConversationInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConversationName = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;

  opacity: 0;
  transition: opacity 0.2s, color 0.2s;

  ${ConversationItem}:hover & {
    opacity: 1;
  }
`;
